import type { LegacySubscription } from '../../types';

import { hasPlan } from './hasPlan';

export function hasSubscription(legacySubscription: LegacySubscription) {
  const { isCanceled } = legacySubscription;
  return !isCanceled && hasPlan(legacySubscription);
}
